<template>
  <div class="shcl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="处理状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="待处理" :value="0" />
                <el-option label="已处理" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="原正单号"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="处理状态"
                    width="120"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="warning">待处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="danger">已驳回</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返修单"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#67C23A" v-if="scope.row.reworkid"><i class="el-icon-success"></i></span>
                      <span style="color:#F56C6C" v-if="!scope.row.reworkid"><i class="el-icon-error"></i></span>
                      <span style="color:#99a9bf">返修单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="判定单"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#67C23A" v-if="scope.row.decisionid"><i class="el-icon-success"></i></span>
                      <span style="color:#F56C6C" v-if="!scope.row.decisionid"><i class="el-icon-error"></i></span>
                      <span style="color:#99a9bf">判定单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.mark===0" size="mini" @click.stop="oper(scope.row, 0)" icon="el-icon-edit-outline">立即处理</el-button>
                      <el-dropdown v-if="scope.row.mark!==0" size="small" @click.stop="view(scope.row)" split-button icon="el-icon-search">
                        <i class="el-icon-search"></i> 查看
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="oper(scope.row, 1)"><i class="el-icon-edit-outline"></i> 修改</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后处理"
      :visible.sync="editVisible"
      width="762px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" v-loading="fullscreenLoading" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="订单信息" prop="orderinfo">
          <el-card shadow="hover" style="font-size: 12px;">
            <div>
              <span style="color:#99a9bf">订单号：</span>
              <span style="color:#606266">{{editForm.ordernum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">原正单号：</span>
              <span style="color:#606266">{{editForm.productnum}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">经销商：</span>
              <span style="color:#606266">{{editForm.delname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">生产车间：</span>
              <span style="color:#606266">{{editForm.factory}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">设计师：</span>
              <span style="color:#606266">{{editForm.designername}}</span>
              <span style="color:#99a9bf;margin-left: 20px">客服人员：</span>
              <span style="color:#606266">{{editForm.servicename}}</span>
              <span style="color:#99a9bf;margin-left: 20px">正单总额：</span>
              <span style="color:#606266">{{editForm.oldamount}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">客诉反应时间：</span>
              <span style="color:#606266">{{editForm.time}}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">终端地址：</span>
              <span style="color:#606266">{{editForm.address}}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">售后/投诉内容：</span>
              <span style="color:#606266">{{ editForm.content }}</span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-if="editForm.bid == 3" label="售后部处理意见" prop="afterSale">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>售后部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input type="textarea" v-model="editForm.opinions.afterSale" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.bid == 3" label="生产部处理意见" prop="production">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>生产部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input type="textarea" v-model="editForm.opinions.production" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.bid == 3" label="销售部处理意见" prop="sales">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>销售部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input type="textarea" v-model="editForm.opinions.sales" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.bid != 3" label="返修单" prop="reworkid">
          <SingleFile v-model="editForm.reworkid" :key="fileLoad" :accept="'.xls,.xlsx'" :old="oldFile" :tip="'只能上传Excel'"></SingleFile>
        </el-form-item>
        <el-form-item label="判定单" prop="decisionid">
          <SingleImg v-model="editForm.decisionid" :key="imgLoad" :oldurl="oldImg" ></SingleImg>
        </el-form-item>
        <el-form-item label="责任部门" prop="rson">
          <el-cascader v-model="editForm.rson" @change="changeRson" :props="manySelect" style="width:100%" :options="afterReasonOption" filterable clearable></el-cascader>
        </el-form-item>
        <el-form-item v-if="editForm.rsonInfo.length>0">
          <el-row v-for="(item, index) in editForm.rsonInfo" :key="item.key" class="after-rson-list">
            <el-col :span="11" style="padding-right: 6px">
              <el-form-item :prop="'rsonInfo.' + index +'.num'" :rules="rsonInfoRules.num">
                <el-input v-model="item.num" prefix-icon="el-icon-news" placeholder="不良数量" type="number">
                  <template slot="prepend"><span style="font-weight: bold;margin-right: 10px"><i class="el-icon-paperclip"></i> {{item.dept}}</span>{{item.rson}}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item :prop="'rsonInfo.' + index +'.remark'">
                <el-input v-model="item.remark" placeholder="备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="责任车间" prop="gourpid">
          <el-select v-model="editForm.gourpid" style="width:100%" filterable clearable>
            <el-option
              v-for="item in groupList"
              v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand"
              :key="item.factory_id"
              :label="item.simple_name"
              :value="item.factory_id">
              <span style="float: left">{{ item.simple_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.factory_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后赔款" prop="amount">
          <el-input v-model="editForm.amount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="售后备注" prop="remark">
          <el-input type="textarea" v-model="editForm.remark" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button icon="el-icon-printer" size="small" @click="printPaper">打印投诉处理单</el-button>
        <el-button type="primary" :loading="auditLoading" size="small" @click="subEdit('editForm')">{{isEdited!==1?'立即提交':'立即修改'}}</el-button>
        <el-button type="danger" v-if="isEdited!==1" :loading="auditLoading" size="small" @click="turn('editForm')">驳回</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="售后处理详情"
      :visible.sync="infoVisible"
      width="762px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>订单号</th>
          <td>{{infoData.order.ordernum}}</td>
          <th>原正单号</th>
          <td>{{infoData.order.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{infoData.order.all_name}}</td>
          <th>生产车间</th>
          <td>{{infoData.order.product_factory}}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td colspan="3">{{infoData.order.time}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{infoData.order.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{infoData.afterSale.content}}</td>
        </tr>
        <tr v-if="infoData.order.bid == 3">
          <th>售后部<br />处理意见</th>
          <td colspan="3">{{ infoData.opinions.afterSale }}</td>
        </tr>
        <tr v-if="infoData.order.bid == 3">
          <th>生产部<br />处理意见</th>
          <td colspan="3">{{ infoData.opinions.production }}</td>
        </tr>
        <tr v-if="infoData.order.bid == 3">
          <th>销售部<br />处理意见</th>
          <td colspan="3">{{ infoData.opinions.sales }}</td>
        </tr>
        <tr v-if="infoData.order.bid != 3">
          <th>返修单</th>
          <td colspan="3">
            <span v-if="infoData.afterSale.reworkid" @click="downFile(infoData.afterSale.reworkid)" class="tcf-link">
              <i class="el-icon-download"></i> {{ infoData.afterSale.reworkname }}
            </span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              v-if="infoData.afterSale.decision_url"
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[infoData.afterSale.decision_url]"
              :src="infoData.afterSale.decision_url">
            </el-image>
          </td>
        </tr>
        <tr>
          <th style="width:80px">责任部门<br>售后原因</th>
          <td colspan="3">
            <el-table
              size="mini"
              :data="infoData.deptRson"
              style="width: 100%">
              <el-table-column
                prop="deptname"
                label="责任部门"
                align="center"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="rsonname"
                label="售后原因"
                align="center"
                width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="num"
                label="不良数量"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="remark"
                align="center"
                label="备注"
                show-overflow-tooltip>
              </el-table-column>
            </el-table>

          </td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{infoData.factory}}</td>
          <th>售后赔款</th>
          <td>{{infoData.afterSale.amount}}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{infoData.afterSale.remark}}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{infoData.afterSale.username}}</td>
          <th>处理时间</th>
          <td>{{infoData.afterSale.opertime}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-popconfirm
          v-if="infoData.order.mark!==100"
          :key="popKey"
          style="margin-right: 15px;"
          title="您确定要完成此订单吗？"
          confirmButtonText="确定"
          cancelButtonText="不用了"
          icon="el-icon-info"
          @onConfirm="overOrder"
        >
          <el-button :loading="overLoading" size="small" slot="reference" type="primary">订单完成</el-button>
        </el-popconfirm>
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getAfterProcessList,
  getAfterSalePageInfo,
  getAfterReason,
  getFactoryList,
  turnDownAfterSale,
  editAfterSaleInfo,
  printComplaintsSale,
  orderOver,
  getGroupInfoByUser
} from '@/api/erp'
import SingleFile from '@/components/upload/SingleFile'
import SingleImg from '@/components/upload/SingleImg'
import { getFileInfo } from '@/api/pub'
import qs from 'qs'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'shcl',
  computed: {
    user: getUser
  },
  components: {
    SingleFile,
    SingleImg
  },
  data() {
    return {
      fullscreenLoading: false,
      afterReasonOption: [],
      groupList: [],
      searchForm: {
        search: '',
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      infoVisible: false,
      oldFile: [],
      oldImg: '',
      manySelect: { multiple: true },
      isEdited: 0,
      editForm: {
        asid: null,
        ordernum: '',
        productnum: '',
        designername: '',
        servicename: '',
        oldamount: null,
        factory: '',
        delname: '',
        address: '',
        time: '',
        content: '',
        reworkid: '',
        decisionid: null,
        rtid: null,
        arid: null,
        gourpid: null,
        amount: null,
        rson: [],
        remark: '',
        opinions: {},
        rsonInfo: []
      },
      rsonInfoRules: {
        num: [{ required: true, message: '请输入不良数量', trigger: 'blur' }]
      },
      editRules: {
        reworkid: [{ required: false, message: '请上传返修单', trigger: 'change' }],
        decisionid: [{ required: false, message: '请上传判定单', trigger: 'change' }],
        rson: [{ required: true, message: '请选择责任部门', trigger: 'change' }],
        rsonInfo: [{ required: true, message: '请选择售后原因', trigger: 'change' }],
        gourpid: [{ required: true, message: '请选择责任车间', trigger: 'change' }],
        remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      auditLoading: false,
      fileLoad: '',
      imgLoad: '',
      infoData: {
        rson: '',
        factory: '',
        deptRson: [],
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null
        },
        opinions: {}
      },
      overLoading: false,
      popKey: '',
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    this.getData()
    getAfterReason().then(response => {
      let afterReasonOption = []
      for (let r of response.data) {
        let children = []
        for (let a of r.list) {
          children.push({ value: a.rid, label: a.name })
        }
        afterReasonOption.push({ value: r.arid, label: r.name, children: children })
      }
      this.afterReasonOption = afterReasonOption
    }).catch(() => {})
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.groupList = response.data
    }).catch(() => {})
  },
  methods: {
    changeRson() {
      if (this.editForm.rson.length > 0) {
        var _rsonInfo = []
        for (const r of this.editForm.rson) {
          let _dept = ''
          let _rson = ''
          for (const ar of this.afterReasonOption) {
            if (r[0] === ar.value) {
              _dept = ar.label
              for (const rson of ar.children) {
                if (r[1] === rson.value) {
                  _rson = rson.label
                  break
                }
              }
              break
            }
          }
          _rsonInfo.push({ arid: r[0], rid: r[1], dept: _dept, rson: _rson, num: null, remark: '' })
        }
        var delindex = []
        for (let i = 0; i < this.editForm.rsonInfo.length; i++) {
          const old = this.editForm.rsonInfo[i]
          let ishave = false
          for (const r of _rsonInfo) {
            if (old.arid === r.arid && old.rid === r.rid) {
              ishave = true
              break
            }
          }
          if (!ishave) {
            delindex.push(i)
          }
        }
        for (const i of delindex) {
          this.editForm.rsonInfo.splice(i, 1)
        }
        for (const r of _rsonInfo) {
          let ishave = false
          for (const old of this.editForm.rsonInfo) {
            if (old.arid === r.arid && old.rid === r.rid) {
              ishave = true
              break
            }
          }
          if (!ishave) {
            this.editForm.rsonInfo.push(r)
          }
        }
      } else {
        this.editForm.rsonInfo = []
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getAfterProcessList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    view(row) {
      this.fullscreenLoading = true
      this.infoData.deptRson = []
      getAfterSalePageInfo({ afterid: row.after_id }).then(response => {
        this.infoData = response.data
        this.infoData.factory = this.infoData.afterSale.factory
        this.infoData.deptRson = this.infoData.afterSale.reasonList
        this.infoData.opinions = this.infoData.afterSale.opinions ? JSON.parse(this.infoData.afterSale.opinions) : {},
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.popKey = new Date().getTime()
      this.infoVisible = true
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '返修单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    oper(row, n) {
      this.isEdited = n
      this.fullscreenLoading = true
      this.editForm.asid = row.after_id
      this.editForm.rson = []
      getAfterSalePageInfo({ afterid: row.after_id }).then(response => {
        this.editForm.ordernum = response.data.order.ordernum
        this.editForm.productnum = response.data.order.beforenum
        this.editForm.factory = response.data.order.product_factory
        this.editForm.delname = response.data.order.all_name
        this.editForm.time = response.data.order.time
        this.editForm.address = response.data.order.address
        this.editForm.designername = response.data.order.designername
        this.editForm.servicename = response.data.order.servicename
        this.editForm.oldamount = response.data.order.oldamount
        this.editForm.bid = response.data.order.bid
        this.editForm.content = response.data.afterSale.content
        // 处理售后原因的多选
        const manyReason = response.data.afterSale.reasonList
        const reasonArr = []
        const _rsonInfo = []
        for (const reason of manyReason) {
          const reasonItem = []
          reasonItem.push(reason.arid)
          reasonItem.push(reason.rid)
          reasonArr.push(reasonItem)
          _rsonInfo.push({ arid: reason.arid, rid: reason.rid, dept: reason.deptname, rson: reason.rsonname, num: reason.num, remark: reason.remark })
        }
        this.editForm.rson = reasonArr
        this.editForm.rsonInfo = _rsonInfo
        this.editForm.reworkid = ''
        if (response.data.afterSale.reworkid) {
          this.oldFile = [{ name: response.data.afterSale.reworkname, id: response.data.afterSale.reworkid }]
        } else {
          this.oldFile = []
        }
        this.fileLoad = new Date().getTime()
        if (response.data.afterSale.decisionid) {
          this.editForm.decisionid = { imgid: response.data.afterSale.decisionid, imgurl: response.data.afterSale.decision_url }
          this.oldImg = response.data.afterSale.decision_url
        } else {
          this.editForm.decisionid = null
          this.oldImg = ''
        }
        this.imgLoad = new Date().getTime()
        if (response.data.afterSale.gourpid !== 0) {
          this.editForm.gourpid = response.data.afterSale.gourpid
        } else {
          if (response.data.order.oldgroupid !== 0) {
            this.editForm.gourpid = response.data.order.oldgroupid
          } else {
            this.editForm.gourpid = null
          }
        }
        this.editForm.amount = response.data.afterSale.amount
        this.editForm.remark = response.data.afterSale.remark
        this.editForm.opinions = response.data.afterSale.opinions ? JSON.parse(response.data.afterSale.opinions) : {}
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.editRules.reworkid[0].required = false
      this.editRules.decisionid[0].required = false
      this.editRules.rson[0].required = true
      this.editRules.rsonInfo[0].required = true
      this.editRules.gourpid[0].required = true
      this.rsonInfoRules.num[0].required = true
      this.editRules.remark[0].required = false
      this.editVisible = true
    },
    turn(formName) {
      this.editRules.reworkid[0].required = false
      this.editRules.decisionid[0].required = false
      this.editRules.rson[0].required = false
      this.editRules.rsonInfo[0].required = false
      this.editRules.gourpid[0].required = false
      this.rsonInfoRules.num[0].required = false
      this.editRules.remark[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.auditLoading) {
            this.auditLoading = true
            const data = {
              userid: this.user.dUserid,
              afterid: this.editForm.asid,
              reason: this.editForm.remark
            }
            turnDownAfterSale(data).then(response => {
              this.$message({
                message: '售后申请已驳回',
                type: 'success'
              })
              this.auditLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.auditLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.reworkid[0].required = false
      this.editRules.decisionid[0].required = false
      this.editRules.rson[0].required = true
      this.editRules.rsonInfo[0].required = true
      this.editRules.gourpid[0].required = true
      this.editRules.remark[0].required = false
      this.rsonInfoRules.num[0].required = true
      let isok = false
      if (this.isEdited === 1) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            isok = true
          }
        })
      } else {
        if (this.editForm.reworkid && this.editForm.decisionid) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              isok = true
            }
          })
        } else {
          isok = true
        }
      }
      if (isok) {
        if (!this.auditLoading) {
          this.auditLoading = true
          let imgid = ''
          if (this.editForm.decisionid !== null && this.editForm.decisionid !== undefined) {
            imgid = this.editForm.decisionid.imgid
          }
          // 责任原因多选数组
          let reasonArr = []
          for (let i = 0; i < this.editForm.rson.length; i++) {
            const obj = {
              key: this.editForm.rson[i][0],
              value: this.editForm.rson[i][1],
              num: 0,
              remark: ''
            }
            for (const ri of this.editForm.rsonInfo) {
              if (obj.key === ri.arid && obj.value === ri.rid) {
                if (ri.num !== null && ri.num !== undefined) {
                  obj.num = ri.num
                }
                obj.remark = ri.remark
                break
              }
            }
            reasonArr.push(obj)
          }
          const s = qs.parse(reasonArr)
          const data = {
            userid: this.user.dUserid,
            afterid: this.editForm.asid,
            fileid: this.editForm.reworkid,
            imgid: imgid,
            money: this.editForm.amount,
            gourpid: this.editForm.gourpid,
            remark: this.editForm.remark,
            opinions: JSON.stringify(this.editForm.opinions),
            reasonStr: s,
            isEdited: this.isEdited
          }
          editAfterSaleInfo(data).then(response => {
            this.$message({
              message: '售后处理提交成功',
              type: 'success'
            })
            this.auditLoading = false
            this.editVisible = false
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        } else {
          return false
        }
      }
    },
    printPaper() {
      // this.$router.push({ path: '/work/test/'})
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        const printLoading = this.$loading({
          lock: true,
          text: '售后/投诉处理单正在打印，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        printComplaintsSale({ afterid: this.editForm.asid }).then(response => {
          LODOP.PRINT_INIT('售后/投诉处理单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          printLoading.close()
        }).catch(() => {
          printLoading.close()
        })
      }
    },
    overOrder() {
      this.overLoading = true
      const data = {
        userid: this.user.dUserid,
        orderid: this.infoData.order.orderid,
        remark: '售后直接完成'
      }
      orderOver(data).then(response => {
        this.$message({
          message: '订单已完成',
          type: 'success'
        })
        this.overLoading = false
        this.infoVisible = false
        this.infoData.order.mark = 100
        this.getData()
      }).catch(() => {
        this.overLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.shcl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
